import { GapOfferView } from '@elva/ui';
import { useNavigate, useParams } from 'react-router-dom';
import { useClearPageTopBarActions } from '@/app/layouts/pageTopBar';

/**
 * The Gap Filler offer editor (amendment 26 §6). Two steps, full width, no
 * settings sub-menu — the same shape as the reminders editors.
 */
export function GapOfferPage() {
  useClearPageTopBarActions();
  const navigate = useNavigate();
  const { page } = useParams<{ page: string }>();
  const which = page === 'test' ? 'test' : 'messages';

  return (
    <GapOfferView
      page={which}
      onBack={() => { void navigate('/settings/ai/gap-filler'); }}
      onGoTo={(p) => { void navigate(`/settings/ai/gap-filler/offer/${p}`); }}
      onSave={() => { void navigate('/settings/ai/gap-filler'); }}
    />
  );
}
